import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
  OnInit,
  inject
} from '@angular/core';

import { AppUpdateService } from '../../../services/app-version.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-update-fullscreen',
  templateUrl: './update-fullscreen.component.html',
  styleUrls: ['./update-fullscreen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule] // <--- aquí incluimos NgIf, NgFor, etc.
})
export class UpdateFullscreenComponent implements OnInit, OnDestroy {
  visible = false;
  updateInfo: any = null;

  private readonly updateSvc = inject(AppUpdateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    //console.log('[UpdateFullscreen] ngOnInit - subscribe modalVisible$');
    // mover suscripciones a ngOnInit evita problemas de creación/destrucción temprana
    this.updateSvc.modalVisible$.pipe(takeUntil(this.destroy$)).subscribe({
      next: v => {
      //  console.log('[UpdateFullscreen] modalVisible$', v);
        this.visible = !!v;
        this.mark();
      },
      error: err => console.error('[UpdateFullscreen] modal error', err)
    });

    this.updateSvc.update$.pipe(takeUntil(this.destroy$)).subscribe({
      next: info => {
        console.log('[UpdateFullscreen] update$', info);
        this.updateInfo = info;
        this.mark();
      },
      error: err => console.error('[UpdateFullscreen] update$ error', err)
    });
  }

  ngOnDestroy(): void {
    //console.log('[UpdateFullscreen] ngOnDestroy - cleaning subscriptions');
    this.destroy$.next();
    this.destroy$.complete();
  }

  private mark() {
    // OnPush friendly: intenta markForCheck y en fallback detectChanges
    try {
      this.cdr.markForCheck();
    } catch {
      try {
        this.cdr.detectChanges();
      } catch {
        /* noop */
      }
    }
  }

  async goUpdate() {
    try {
      // usar la firma correcta: pasar objeto, no booleano
      await this.updateSvc.openStore({
        androidPackageName: 'com.logiciel.meprestas',
        appId: '6743812196'
      });
    } catch (err) {
      console.warn('[UpdateFullscreen] openStore error', err);
      // fallback abrir URL pública
      try {
        window.open(
          'https://play.google.com/store/apps/details?id=com.logiciel.meprestas',
          '_blank'
        );
      } catch {}
    }
  }

  hideForDev() {
    this.updateSvc.hideModal();
  }
}
